export default function () {
	const container = document.querySelector('.b-screenshot-slider__slider-con');
	const track = container?.querySelector('.b-screenshot-slider__track');
	if (!container || !track) return;

	const originalItems = Array.from(track.children);
	if (!originalItems.length) return;

	let lastWidth = 0;

	const setup = () => {
		const containerWidth = container.offsetWidth;

		// Avoid recalculation if width did not change
		if (containerWidth === lastWidth) return;
		lastWidth = containerWidth;

		// Reset track to original state
		track.innerHTML = '';
		originalItems.forEach((item) => {
			track.appendChild(item);
		});

		let trackWidth = track.scrollWidth;

		// Duplicate until wide enough
		while (trackWidth < containerWidth * 2) {
			originalItems.forEach((item) => {
				track.appendChild(item.cloneNode(true));
			});
			trackWidth = track.scrollWidth;
		}

		track.style.setProperty('--marquee-width', `${trackWidth / 2}px`);
	};

	setup();

	const observer = new ResizeObserver(() => {
		setup();
	});

	observer.observe(container);
}
